import { render, staticRenderFns } from "./BulkRedtailDossierUpdateModal.vue?vue&type=template&id=01fae0d4&scoped=true&"
import script from "./BulkRedtailDossierUpdateModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./BulkRedtailDossierUpdateModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BulkRedtailDossierUpdateModal.vue?vue&type=style&index=0&id=01fae0d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fae0d4",
  null
  
)

export default component.exports